module.exports = __webpack_public_path__ + "static/img/theme_06.95a01453.png";